import React, {Component} from "react";
import Select from 'react-select';
import 'react-select/dist/react-select.css';

class DropDownMultiSelect extends Component {

    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect(value) {
        if (this.props.handlerFromParent) {
            this.props.handlerFromParent(value);
        }
    }

    render() {
        return (
            <Select
                placeholder={this.props.placeholder || "Select"}
                name={this.props.name || "multiSelect"}
                autoFocus={false}
                multi={true}
                searchable={this.props.searchable !== false}
                clearable={this.props.clearable === true}
                disabled={this.props.disabled}
                value={this.props.selectedValues}
                options={Array.isArray(this.props.options) ? this.props.options : []}
                onChange={value => this.handleSelect(value)}
            />
        );
    }
}

export {DropDownMultiSelect};
